import { AuditOutlined } from '@ant-design/icons';

import OrderPage from '../pages/OrderPage';

import { SiteMap } from './index';

export const orderRoutes: SiteMap = {
  order: {
    title: '주문 관리',
    page: OrderPage,
    key: '/order',
    icon: <AuditOutlined />,
  },
  // 'store-issue': {
  //   title: '(구) 이슈 관리',
  //   page: StoreIssuePage,
  //   key: '/store-issue',
  //   icon: <WarningOutlined />,
  //   children: [
  //     {
  //       label: '(구) 이슈 목록',
  //       icon: null,
  //       key: '/store-issue/list',
  //     },
  //     {
  //       label: '(구) 이슈 출력',
  //       icon: null,
  //       key: '/store-issue/print',
  //     },
  //   ],
  // },
};
